import { getEnv } from "./env";

/** Build provenance baked in at compile time — see `define` in vite.config.mts. */
export type BuildInfo = {
  /** `package.json` version. */
  version: string;
  /** Azure DevOps build number, or the short commit when built outside CI. */
  buildId: string;
  /** Short commit SHA, empty when it could not be resolved. */
  commit: string;
};

export const buildInfo: BuildInfo = __BUILD_INFO__;

/**
 * The short label shown in the UI, e.g. `v0.1.0 · 20260827.3`.
 *
 * The build id is what pins a session to a specific deploy — the version alone
 * moves too rarely to tell two releases apart.
 */
export const formatBuildLabel = (info: BuildInfo = buildInfo): string =>
  info.buildId ? `v${info.version} · ${info.buildId}` : `v${info.version}`;

/**
 * One line a user can paste into a support request. Carries the commit too —
 * it is what support traces back to a deploy — even though the visible label
 * keeps it out of the way.
 */
export const formatSupportDetails = (
  info: BuildInfo = buildInfo,
  environment: string = getEnv("VITE_ENV")
): string =>
  [
    `MEDirect Report Studio v${info.version}`,
    info.buildId && `build ${info.buildId}`,
    info.commit && `commit ${info.commit}`,
    environment,
  ]
    .filter(Boolean)
    .join(" · ");
